import React from 'react';

//Rutas
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

//paginas
import NegociosPage from './pages/Negocios/negocios.page';
// import ActivatePage from './Pages/Activate/activate.page';
// import InformacionPersonalComponent from './Components/InformacionPersonal/InformacionPersonal.component';
// import PreguntasComponent from './Components/Preguntas/preguntas.component';
import Catalogo from './Components/Catalogo/catalogo.page';
import Sucursales from './Components/Sucursal/sucursales.component';
import HomePage from './pages/Home/home.page';
import detalleProducto from './Components/DetalleProducto/detalleProducto.component';
import MisDatos from './Components/MisDatos/misDatos.component'
import ThankYou from './Components/ThankYou/ThankYou'
import Checkout from './Components/Checkout/checkout'
import PreguntasFrecuentes from './Components/Preguntas/preguntasFrecuentes.component'
import TerminosLegales from './Components/TerminosLegales/terminosLegales.component';
import CargaMasiva from './Components/CargaMasiva/ContentCargaMasiva'


//stilos spinner
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

//msal
import { MsalProvider } from "@azure/msal-react";
// import RefreshToken from './Msal/RefreshTOken';
// import { loginRequest } from "./Msal/authConfig";

//estilos
import './styles/app.scss';
import 'font-awesome/css/font-awesome.min.css';

//Redux
import store from './Redux/store';
import { Provider } from 'react-redux';

// import { Redemption } from './Components/Checkout/Redencion/Redemption.page';
//auth
import auth from './Helpers/auth'
// AGREGA TOKEN AL ENCABEZADO
auth.headerToken();
auth.ValidateExp();

function App({ pca }) {

  let user = JSON.parse(auth.getUsuario());

  if (user) {
    idleLogout()
  }

  const NotFoundRedirect = () => <Redirect to='/' />
  //const urlBase = ''; // QA
  const urlBase = '/negocios'; // PRD

  return (
    <Provider store={store}>
      <BrowserRouter basename={urlBase}>
        <MsalProvider instance={pca}>
          <Switch>
            <PrivateRoute exact path="/inicio" component={HomePage} />
            <Route exact path="/" component={NegociosPage} ></Route>
            <PrivateRoute exact path="/thankyou/:orden" component={ThankYou}></PrivateRoute>
            <PrivateRoute exact path="/CargaMasiva" component={CargaMasiva} />
            {/**<Route exact path="/activate" component={ActivatePage} ></Route>*/}
            <PrivateRoute exact path="/catalogo/:tipo/:id/:categoria" component={Catalogo} />
            <PrivateRoute exact path="/PreguntasFrecuentes" component={PreguntasFrecuentes} />
            <PrivateRoute exact path={["/catalogo/:tipo/:id/:categoria/:page", "/catalogo/:tipo/:id/:categoria/:busqueda/:page"]} component={Catalogo} />
            {/* <Route exact path="/catalogo/:ca/:op" component={Catalogo} ></Route> */}
            <PrivateRoute exact path="/Sucursales" component={Sucursales} />
            <PrivateRoute exact path="/MiPerfil/:tipo" component={MisDatos} />
            {/* <Route exact path="/test" component={Test} ></Route> */}
            {/* <Route exact path="/activate/informacion/personal" component={InformacionPersonalComponent} />*/}
            {/*<Route exact path="/activate/preguntas/seguridad" component={PreguntasComponent} />*/}
            <PrivateRoute exact path="/detalleProducto/:producto" component={detalleProducto} />
            <PrivateRoute exact path="/carrito" component={Checkout} />
            {/* <PrivateRoute exact path="/carrito/:codigoSku" component={Redemption} /> */}
            <Route exact path="/terminosLegales" component={TerminosLegales} />
            <Route component={NotFoundRedirect} />
          </Switch>
        </MsalProvider>
      </BrowserRouter>
    </Provider>
  );
}

//Funcion LogOut
function idleLogout() {
  var t;
  window.onload = resetTimer;
  window.onmousemove = resetTimer;
  window.onmousedown = resetTimer;  // catches touchscreen presses as well      
  window.ontouchstart = resetTimer; // catches touchscreen swipes as well 
  window.onclick = resetTimer;      // catches touchpad clicks as well
  window.onkeypress = resetTimer;
  window.addEventListener('scroll', resetTimer, true); // improved; see comments

  function logOut() {
    auth.signOut()
    setTimeout(() => {
      const publicUrl = process.env.PUBLIC_URL;
      const urlBase = publicUrl.substring(publicUrl.lastIndexOf('/') + 1);
      window.location.href = urlBase;
    }, 500)
  }

  function resetTimer() {
    clearTimeout(t);
    t = setTimeout(logOut, (60 * 60000));  // time is in milliseconds
  }
}



// RUTAS PRIVADAS
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    auth.getToken()
      ? <Component {...props} />
      : <Redirect to='/' />
  )} />
)

export default App;
